<template>
  <section class="py-4">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 shadow text-just-inline-150">
          <header-paragraph v-for="topic in topics" v-bind:key="topic"
                            :title="getTitle(topic)"
                            :paragraphs="getTermsConditions(topic)"
          />
          <hr>
          <p>This Terms and Conditions page was generated by
            <a href="https://app-privacy-policy-generator.nisrulz.com/" target="_blank" rel="noopener noreferrer">App Privacy Policy Generator</a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { replaceContentGlobalConstants } from '@/utils/content';
import { mapGetters } from 'vuex';
import HeaderParagraph from '@/components/ui/HeaderParagraph.vue';

export default {
  name: 'TermsConditions',
  components: { HeaderParagraph },
  data() {
    return {
      topics: [
        'generalTermsConditions',
        'modificationsTermsConditions',
        'contactTermsConditions',
      ],
    };
  },
  created() {
    this.$store.dispatch('content/loadContentForView', 'termsConditions');
  },
  computed: {
    ...mapGetters({
      termsConditionsContent: 'content/getTermsConditionsContent',
    }),
  },
  methods: {
    getTermsConditions(typeOfTerms) {
      return this.termsConditionsContent && this.termsConditionsContent[typeOfTerms]
        ? this.termsConditionsContent[typeOfTerms].paragraphs
          .map((p) => replaceContentGlobalConstants(p))
        : [];
    },
    getTitle(typeOfTerms) {
      return this.termsConditionsContent && this.termsConditionsContent[typeOfTerms]
        ? this.termsConditionsContent[typeOfTerms].title
        : '';
    },
  },
};
</script>

<style scoped>
.text-just-inline-150 {
  line-height: 150%;
  text-align: justify
}
</style>
